/*function isIE () {
	var myNav = navigator.userAgent.toLowerCase();
	return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
}
if (isIE () && isIE () < 9) {
	var no_support_page = 'browser-not-supported';
	if (window.location.href.indexOf("browser-not-supported") == -1) {
		window.location = '/'+no_support_page;
	}
	
} */


jQuery( document ).ready(function($) {

	var url_arg = get_url_arg();
	/*//---------------------------
	// Mouse detection
	//---------------------------
	var $body = $("body");
	$body.addClass('no_mouse');
	$body.on({
		mousemove: function(e) {
			setTimeout(function(){
					var $body = $("body");
					var last_click = $body.data('lastClick');
					var d = new Date();
					//console.log(''+last_click +' + 20 < --- '+d.getTime());
					if (typeof last_click === 'undefined' || parseInt(last_click) + 20 < d.getTime()) { 
						$body.unbind('mousemove');
						$body.removeClass('no_mouse').addClass('mouse_detected');
					}
			},10);
			
		},
		click: function(e) { //fix bug because 'click' trigger 'mousemove'
			var d = new Date();
			$body.data('lastClick', d.getTime());
		}
	});*/

	
	//---------------------------
	// VC fix empty row
	//---------------------------
	$(window).resize(function() {
			fix_empty_row();
	});
	
	function fix_empty_row(){
	
		$('.wpb_column > .vc_column-inner > .wpb_wrapper ').each(function(){
			if ($(this).html() == ''){
				var screen_size = $(window).width() + 17;
				var reduce = false;
				if (screen_size < 767 ){ reduce = true;}
				if (reduce ){
					$(this).closest('.wpb_column').hide();
				}
			}
		});
	}
	
	//init 
	fix_empty_row();
	
	//---------------------------
	// VC fix Padding top of no background element
	//---------------------------
	$('.vc_wrap > .vc_row').each(function(){
		var $select = $(this);
		var $prev = $select.prev();
		if ($prev.is('.vc_row-full-width')){$prev = $prev.prev();}

		if (	$prev.is('.vc_row') 
			&& !($prev.is('.vc_row-has-fill') || $prev.find('.vc_col-has-fill').exist())  // if $prev have no bg on row or child 
			&& !($select.is('.vc_row-has-fill') || $select.find('.vc_col-has-fill').exist())  // if $select have no bg on row or child 
			){ 
				$select.addClass('no_space_top');
		}
	});
	
	//---------------------------
	// Responsive menu
	//---------------------------

	/*var $responsive_menu = $(".responsive_menu_wrap");
	var $responsive_menu_icon = $(".responsive_menu_icon");
	
	$('.open_responsive_menu').click(function(){

		if ($($responsive_menu.selector).hasClass('active')){
				close_resp_menu();
		}
		else{
				open_resp_menu();
		}
	});
	$(document).click(function (e){

		if ( 
			!$responsive_menu_icon.is(e.target) // if the target of the click isn't the container...
			&& $responsive_menu_icon.has(e.target).length === 0 // ... nor a descendant of the container
			) 
		{
			close_resp_menu();
		}
		
	});
	
	function open_resp_menu(){
		$responsive_menu.addClass('active');
		$responsive_menu_icon.addClass('active');
		$responsive_menu_icon.find('.hamburger').addClass('is-active');
	}
	function close_resp_menu(){
		$responsive_menu.removeClass('active');
		$responsive_menu_icon.removeClass('active');
		$responsive_menu_icon.find('.hamburger').removeClass('is-active');
	}*/
	var $responsive_menu = $(".responsive_menu_wrap");
	var $responsive_menu_icon = $(".responsive_menu_icon");
	
	$('.open_responsive_menu').click(function(){
		if ($($responsive_menu.selector).hasClass('active')){
				close_resp_menu();
		}
		else{
				open_resp_menu();
		}
	});
	
	$(document).click(function (e){
		if ( 
			!$responsive_menu_icon.is(e.target) // if the target of the click isn't the container..
			&& $responsive_menu_icon.has(e.target).length === 0 // ... nor a descendant of the container
			&& !$responsive_menu.is(e.target) //( click is not on resp menu wrap)
			&& $responsive_menu.has(e.target).length === 0 //( or a child )
			){
				close_resp_menu();
		}
		
	});
	
	function open_resp_menu(){
		$responsive_menu.addClass('active');
		$responsive_menu_icon.addClass('active');
		$responsive_menu_icon.find('.hamburger').addClass('is-active');
		$('#wpadminbar').hide();
	}
	function close_resp_menu(){
		$responsive_menu.removeClass('active');
		$responsive_menu_icon.removeClass('active');
		$responsive_menu_icon.find('.hamburger').removeClass('is-active');
		$('#wpadminbar').show();
	}
	
	$('.responsive_menu_wrap .menu-item-has-children a').click(function(){
		var $select = $(this);
		var $li = $(this).closest('li');
		var $submenu = $li.children('.sub-menu');
		if($li.is('.active')){
			 $li.removeClass('active');
			 $submenu.removeClass('active');
		}else{
			$li.addClass('active');
			$submenu.addClass('active');
		}
	});
	
	//Remove empty header from resp menu
	$responsive_menu.find('.responsive_main_menu > li > .sub-menu > li > a').each(function (){
		if ($(this).text().trim() == ''){
			$(this).remove();
		}
	});
	
	
	//---------------------------
	// Color menu if its current page
	//---------------------------
	$('header .main_menu a').each(function(){
		var $select = $(this);
		if ( window.location.href.indexOf($select.attr('href')) > -1 ){$select.addClass('active');}
	});

	//---------------------------
	//Fixed header 
	//---------------------------
	var $header = $("header.main_header");
	var $content = $("#ob_content");
	var header_height = $header.height() ;
	  
	var isShowing = false;
	$(window).scroll(function(e) {
		if ($(window).scrollTop() > header_height ) {
			$header.addClass('fixed');
			$content.css('padding-top', header_height );
			//animation
			if (isShowing == false){
				isShowing = true;
				//$header.css('margin-top', '-'+header_height );
				$header.css('margin-top', '-'+$("header").height()+'px' );
				$header.stop().animate({ marginTop: '0' }, 300);
			}

		} else {
			$header.removeClass('fixed');
			$content.css('padding-top', '0' );
			$header.stop().css('margin-top', '0' );
			isShowing = false;

			
		}
	});
	
	//---------------------------
	//FULL WIDTH 
	//---------------------------
	$('.full_width').full_width();
	$(window).resize(function(){
		$('.full_width').full_width();
	});
	
	
	//---------------------------
	// smooth link
	//---------------------------
	$('*[href]').click(function(e){
		var href = $.attr(this, 'href');
		if (typeof href != 'undefined' && $(href).exist() ){
			e.preventDefault(e);
			$('html, body').animate({
				scrollTop: $(href).offset().top - 80 //minus fixed header height
			}, 500);
		}
	});
	





	//---------------------------
	// pagination
	//---------------------------
	//
	$(".pagination_wrap .page_link").click(function (){
		window.location.href = replaceUrlParam(window.location.href , 'page', $(this).text() );
	});

	//---------------------------
	//	Filter
	//---------------------------
	$('.picked_result_wrap').click(function(){
		var $multi_selec = $(this).closest('.multi_select');
		var is_active = $multi_selec.is('.active');
		close_multi_select();
		if (!is_active){
			open_multi_select($multi_selec);
		}
		
	});


	var $multi_select = $(".multi_select");

	$(document).click(function (e){
		if ( 
			!$multi_select.is(e.target) // if the target of the click isn't the container..
			&& $multi_select.has(e.target).length === 0 // ... nor a descendant of the container
			&& !$multi_select.is(e.target) //( click is not on resp menu wrap)
			&& $multi_select.has(e.target).length === 0 //( or a child )
			){
				close_multi_select();
		}
		
	});


	//search filter
	$('.multi_select.search .search_input').on('keyup', function (e) {
		var text_to_search = $(this).val().toLowerCase();
		$option_tr = $(this).closest('.options').find('table tr');
		$option_tr.removeClass('filtered_out');
		$option_tr.each(function(){
			if($(this).find('label').text().toLowerCase().indexOf(text_to_search) === -1  ){
				$(this).closest('tr').addClass('filtered_out');
			}
		});
	});
	
	//add on option selection
	//$('.multi_select .options input').change(function(){		
	//	add_chosen_field(this);
	$('.multi_select .options tr').click(function(){        
        add_chosen_field($(this).find('input')[0]);
	});
	

	function add_chosen_field(input){
		//var $form = $search_from_page_button.closest('form');
		var $multi_select = $(input).closest('.multi_select');
		var $picked_result_wrap = $multi_select.find('.picked_result_wrap');
		var $picked_result = $picked_result_wrap.find('.picked_result');
		
		if (!$picked_result.is('[original_field]')){
			$picked_result.attr('original_field', $picked_result.html() )
		;}

		if ($multi_select.is('.single_select')){ //reset other input
			$multi_select.find('input[type=checkbox]').not(input).prop('checked', false); 
		}

		//reset filter search option
		/*if ($multi_select.is('.search')){
			$multi_select.find('.search_input').val('');
			$multi_select.find('.options tr').removeClass('filtered_out');
		}*/
		

		var new_field_label = []; // show selected option
		var new_field_val = []; 
		$multi_select.find('.options input').each(function(){
		
			var $select = $(this); 
			
			if ($(this).is('[type=checkbox]') && $(this).attr("checked")){
				new_field_label.push($multi_select.find('label[for="'+ $select.attr('id') + '"]').html());
				new_field_val.push($(this).val());			
			}
		});
		
		
		if (new_field_label.length > 0){ //if something checked
			
			 $picked_result.html('<span class="pick">'+new_field_label.join('</span> <span class="pick">') + '</span>');
			 $multi_select.find('.hidden_input').val(new_field_val.join(','));
			 
		}
		else{
			 $picked_result.html($picked_result.attr('original_field'));
			 $multi_select.find('.hidden_input').val('');
			 
		}

		if ($multi_select.is('.single_select')){
			close_multi_select();
		}
		//reset filter search option
		if ($multi_select.is('.search')){
			$multi_select.find('.search_input').val('').focus();
			$multi_select.find('.options tr').removeClass('filtered_out');
			
		}

	}

	function close_multi_select(){
		$('.multi_select').removeClass('active');
	}
	function open_multi_select($multi_select){
		$multi_select.addClass('active');
	}
	
	$('.filters .update').click(function(){
		var $filters = $(this).closest('.filters');
		var new_url = window.location.href;

		$filters.find('.hidden_input, select , input[type=text]').each(function(){
			var name = $(this).attr('name');
			var value = $(this).val();
			if (value == ''){
				new_url = removeUrlParam (new_url , name );
			}else {
				new_url = replaceUrlParam (new_url , name, value );
			}
		});

		new_url = replaceUrlParam (new_url , 'page', '1' );
		//console.log(new_url);
		window.location.href = new_url;

	});
	$(".filters input[type=text]").on('keyup', function (e) {
		if (e.keyCode == 13) {
			$('.filters .update').click();
		}
	});
	
	//Prefill
	//console.log(url_arg);
	for (var param_name in url_arg){
		var current_arg = url_arg[param_name].split(',');
		//console.log(current_arg);
		for (var k2 in current_arg){
			var value = current_arg[k2];
			
			if ( $('.filters .multi_select .hidden_input[name="'+param_name+'"]').exist()  ){
				$('.filters .multi_select .hidden_input[name="'+param_name+'"]').closest('.filter, .sort').find('.options input[value="'+value+'"]').click();
				//$('.filters .options input[value="'+value+'"]').click();
			}else{
				$('.filters').find('select[name="'+param_name+'"] , input[type=text][name="'+param_name+'"]').val(value);
			}


		}

	}
	//init val
	$('.multi_select[init_val]').each(function(){
		
		var name = $(this).find('.hidden_input').attr('name');
		if (typeof url_arg[name] == 'undefined'){
			var init_val = JSON.parse($(this).attr('init_val'));
			for (var i in init_val){
				$(this).find('.options input[value="'+init_val[i]+'"]').click();
			}
		}
		//if ($(this.attr('init_val'))
	});

	//reponsive
	$('.open_filters').click(function(){
		if ($(this).is('.active')){
			$('.filters').hide();
			$(this).removeClass('active');
		}else{
			$('.filters').show();
			$(this).addClass('active');
		}
	});




	//----------------------



	var $add_new_wrap = $(".ob_resto_list .add_new_wrap");
	$(".ob_resto_list .add_new_button").click(function(){
		open_new_resto_form();
	});


	//close form
	$add_new_wrap.mousedown(function(data, handler){
		if (data.target == this) {		
			close_new_resto_form();
		}
	});
	$(".ob_resto_list .add_new .close").click(function(){
		close_new_resto_form();
	});

	function open_new_resto_form() {
        $add_new_wrap.addClass("active");
    }
    function close_new_resto_form() {
		$add_new_wrap.removeClass("active");
		reset_resto_form();
	}
	function reset_resto_form() {
		$add_new_wrap.find('.input').html('');
		$add_new_wrap.find('input[type=text] ,input[type=hidden] ').val('');
	}
	
	var input_selector = {
		'name' : $add_new_wrap.find(".input_name"),
		'price' : $add_new_wrap.find(".input_price"),
		'location' : $add_new_wrap.find("input[name='location']"),
		'resto_type' : $add_new_wrap.find("input[name='resto_type']"),
	}

	$('.ob_resto_list .add_new_wrap .submit').click(function() {
		
		
		var form_data = {
			'post_id' : 0,
			'logo_id' : $add_new_wrap.find(".file_picker_value").val() //avoid pb with cache
		};
		for (var i in  input_selector){
			//console.log(input_selector[i]);
			var input_temp = input_selector[i];
			form_data[i] = (  input_temp.is('input') ?  input_temp.val() :  input_temp.html() );
		}
		console.log('form_data' , form_data);

		$.ajax({
			type: "POST",
			dataType: "json",
			url: ajaxurl,
			data: {
                action: "add_resto",
                form_data: form_data
            }
		}).done(function(response) {
			console.log(response);
			if (response['status'] == 'success'){
				//window.location.href= response['data']['link'].replace(/\\(.)/mg, "$1");
				window.location.href= response['data']['link'];
				
			}
			
		})
	});


	//------------------------------
	// IMG / FILE PICKER
	//------------------------------
	
	//setup
	var $file_pickers = $('.file_picker');
	
	$file_pickers.each(function(){
		$file_picker = $(this);
		var options = get_gallery_options($file_picker);
		
		var gallery_data = get_gallery_data( $file_picker );

		$file_picker.append('<input type="button" class="file_picker_button" value="'+ options['button_label'] +'"/>');
		$file_picker.append('<input type="hidden" class="file_picker_value" name="'+ $file_picker.attr('field_name') +'" value="'+ get_join_value(gallery_data, 'id') +'"/>');
		
		if ( !$file_picker.is('[preview]') || $file_picker.attr('preview') == 'true' ){
			reset_preview($file_picker);
		};
		
		$file_picker.find('.file_picker_button').click(function( event ){
			event.preventDefault();
			file_pickers_open_selector($(this).closest('.file_picker') , options); //dont use $file_picker, or it will will use the last one only
		});
		
	});
	

	function get_join_value(array, property){
		//if (array.length <= 0 || !array ){return '';}
		if (Object.getOwnPropertyNames(array).length <= 0) return false;
		//console.log(array);
		return array.map(function(elem){
			return elem[property];
		}).join(",");
	}

	function get_gallery_data($file_picker){
		var gallery_data = jQuery.parseJSON( $file_picker.attr('gallery_data')  );
		if ( typeof gallery_data == "undefined" || gallery_data == null){
			gallery_data = {};
		}
		return gallery_data;
	}
	
	//Reset all preview
	function reset_preview($file_picker){
		$file_picker.find('.file_picker_preview').remove();
		var preview_html = '';
		//var img_urls = $file_picker.attr('value_url');
		var gallery_data = get_gallery_data( $file_picker );
		
		for (var i in gallery_data){
			preview_html += '<div class="img_preview" title="'+gallery_data[i]['title']+'" img_id="'+gallery_data[i]['id']+'" url="'+gallery_data[i]['url']+'" style="background-image:url('+gallery_data[i]['url']+');">\
								<div class="img_title">'+gallery_data[i]['title']+'</div>\
							</div>';
		}

		
		$file_picker.prepend('<div class="file_picker_preview">'+preview_html+'</div>');
		
		//dragable gallery
		var $ingredient_list =  $('.file_picker_preview');
		if ($ingredient_list.exist()){
			new Sortable($ingredient_list[0], {
					// Element dragging ended
					onEnd: function (/**Event*/evt) {
						//DEFAULT ACTION
						var itemEl = evt.item;  // dragged HTMLElement 
						evt.to;    // target list 
						evt.from;  // previous list 
						evt.oldIndex;  // element's old index within old parent
						evt.newIndex;  // element's new index within new parent
						
						//CUSTOM ACTION
						reorder_gallery_id($(itemEl));
					},

			});
		}
	}
	
	//return option from attribute
	function get_gallery_options($file_picker){

		//default_options
		var options = {
			'multiple_select' : false, // (false => only 1, true => multiple but hold control to add , 'add' => multiple and click to add )
			'file_type' : "image", // image, application/pdf
			'frame_title' : "Select Files", 
			'frame_button_text' : "Done", 
			'preview' : "true", 
			'button_label':'Choose image',
		}
		
		if ( $file_picker.attr('multiple_select') == "true" ){options['multiple_select'] = 'add';}
		if ( $file_picker.is('[frame_title]') ){options['frame_title'] = $file_picker.attr('frame_title');}
		if ( $file_picker.is('[frame_button_text]') ){options['frame_button_text'] = $file_picker.attr('frame_button_text');}
		if ( $file_picker.is('[file_type]') ){options['file_type'] = $file_picker.attr('file_type');}
		if ( $file_picker.is('[preview]') ){options['preview'] = $file_picker.attr('preview');}
		if ( $file_picker.is('[button_label]') ){options['button_label'] = $file_picker.attr('button_label');}

		return options;
	}
	
	//action
	//$file_pickers.find('.file_picker_button').live('click', function( event ){
	function file_pickers_open_selector($file_picker, options){

		var file_frame;

		var $saved_input = $file_picker.find('.file_picker_value');

		if (typeof options == 'undefined'){
			options = get_gallery_options($file_picker);
		}
		

		// If the media frame already exists, reopen it.
		if ( file_frame ) {
			file_frame.open();
			return;
		}

		// Create the media frame.
		file_frame = wp.media.frames.file_frame = wp.media({
				title: options['frame_title'],
				button: {
					text: options['frame_button_text'],
				},
				library : {
					type : options['file_type'],
				},
				 multiple: options['multiple_select'] 
		});

		// When an image is selected, run a callback.
		file_frame.on( 'select', function() {
					var selection = file_frame.state().get('selection');
					var new_val = [];
					selection.map( function( attachment ) {
						attachment = attachment.toJSON();
						if (typeof attachment.url !== 'undefined' &&  attachment.url != ''){ //ignore previous and deleted attachment
							//console.log(attachment);
							new_val.push({
								'id':attachment.id,
								'url':attachment.url,
								'title':attachment.filename,
							});
						}
					});
					
					
					
					$file_picker.attr('gallery_data' , JSON.stringify(new_val));
					$saved_input.val(get_join_value(new_val, 'id'));
					if (options['preview'] == 'true'){
						reset_preview($file_picker);
					}

		});

		// Finally, open the modal
		file_frame.open();
	
		//after open, pre populate previous data
		if ($saved_input.val() != ''){
			var selection = file_frame.state().get('selection');
			ids = $saved_input.val().split(',');
			ids.forEach(function(id) {
					attachment = wp.media.attachment(id);
					attachment.fetch();
					selection.add( attachment ? [ attachment ] : [] );
			});
		}
	};
	
	

	
	
	function reorder_gallery_id($el){
		
		$file_picker = $el.closest('.file_picker');
		var gallery_data = get_gallery_data( $file_picker );
		
		
		var new_val = [];
		$file_picker.find('.img_preview').each(function(){
			var id = $(this).attr('img_id');
			var url = $(this).attr('url');
			var title = $(this).attr('title');
			//new_val[id] = gallery_data[id];
			new_val.push({
				'id':id,
				'url':url,
				'title':title,
			});
		});
		

		$file_picker.find('.file_picker_value').val(get_join_value(new_val, 'id'));
		$file_picker.attr('gallery_data' , JSON.stringify(new_val));
	}
	
	

});
